import React, { useState } from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { enterEmail } from "../actions/index";
import { stateProps } from "../types";
import ContainerBox from "./common/containerBox.component";
import FormSingleInput from "./form/formSingleInput.component";
import validator from "validator";

const Email: React.FC = () => {
  const dispatch = useDispatch();

  const email = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.email
  );

  const [emailError, setEmailError] = useState("");

  const validateEmail = (e: any) => {
    var email = e.target.value;
    if (validator.isEmail(email)) {
      dispatch(enterEmail(email, false));
      setEmailError("");
    } else {
      dispatch(enterEmail(email, true));
      setEmailError("Please Enter Valid Email!");
    }
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"04"} title={"What is your email address?"} />
        <FormSingleInput
          value={email}
          onInputChange={validateEmail}
          placeholder={"Your email address"}
          emailError={emailError}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Email;
